import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl';
import { ProjectRowLoading } from '../../common';
import { usePaginatedProjectsFilteredByResourceRequestStatusQuery } from '../hooks';
import ProjectRow from './ProjectRow';

const useStyles = makeStyles(theme => ({
  showMoreButton: {
    backgroundColor: theme.palette.grey[100],
    textTransform: 'none',
    width: '100%'
  }
}));

export const ProjectsExpansionPanelDetails = ({
  resourceRequestStatus,
  requestType
}) => {
  const [hasMore, setHasMore] = useState(true);
  const classes = useStyles();
  const {
    loading,
    resourceRequestsProjects = [],
    loadMore
  } = usePaginatedProjectsFilteredByResourceRequestStatusQuery({
    hasMore,
    setHasMore,
    resourceRequestStatus
  });

  return (
    <>
      {resourceRequestsProjects.map(resourceRequestsProject => (
        <ProjectRow
          resourceRequestsProject={resourceRequestsProject}
          key={resourceRequestsProject.project.id}
          requestType={requestType}
        />
      ))}
      {loading && <ProjectRowLoading color={requestType} />}
      {hasMore && !loading && (
        <Button
          data-qe-id={`${requestType}_showMoreButton`}
          className={classes.showMoreButton}
          color="primary"
          onClick={loadMore}
        >
          <FormattedMessage id="projectOverview.showMore" />
        </Button>
      )}
    </>
  );
};

ProjectsExpansionPanelDetails.propTypes = {
  resourceRequestStatus: PropTypes.string,
  requestType: PropTypes.string
};

export default ProjectsExpansionPanelDetails;
